// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.container .card_ {

	height: 400px;
	display: flex;
	justify-content: center;
	align-items: center;
	backdrop-filter: blur(10px);

}

.container .card_ .content {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	transition: 0.5s;
}

.container .card_:hover .content {
	transform: translateY(-20px);
}

.container .card_ .content .imgBx {
	position: relative;
	width: 240px;
	justify-content: center;
	justify-items: center;
	height: 340px;
	overflow: hidden;
	border-top-left-radius: 25px;
	border-bottom-right-radius: 25px;

}

.container .card_ .content .imgBx img {
	position: absolute;
	top: 0;
	left: 0;
}

.container .card_ .content .contentBx h3 {
	color: #fff;
	text-transform: uppercase;
	letter-spacing: 2px;
	font-weight: 500;
	font-size: 15px;
	text-align: center;
	margin: 20px 0 10px;
	line-height: 1.1em;
}

.container .card_ .content .contentBx h3 span {
	font-size: 12px;
	font-weight: 300;
	text-transform: initial;
}

.container .card_ .sci {
	position: absolute;
	bottom: 50px;
	display: flex;
}

.container .card_ .sci li {
	list-style: none;
	margin: 0 10px;
	transform: translateY(40px);
	transition: 0.5s;
	opacity: 0;
}

.container .card_:hover .sci li {
	transform: translateY(0px);
	opacity: 1;
}

.container .card_ .sci li a {
	color: #fff;
	font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/roomsSection.css"],"names":[],"mappings":";;;AAGA;;CAEC,aAAa;CACb,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,2BAA2B;;AAE5B;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,uBAAuB;CACvB,qBAAqB;CACrB,aAAa;CACb,gBAAgB;CAChB,4BAA4B;CAC5B,gCAAgC;;AAEjC;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;AACR;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,2BAA2B;CAC3B,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,0BAA0B;CAC1B,UAAU;AACX;;AAEA;CACC,WAAW;CACX,eAAe;AAChB","sourcesContent":["\n\n\n.container .card_ {\n\n\theight: 400px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackdrop-filter: blur(10px);\n\n}\n\n.container .card_ .content {\n\tposition: relative;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tflex-direction: column;\n\ttransition: 0.5s;\n}\n\n.container .card_:hover .content {\n\ttransform: translateY(-20px);\n}\n\n.container .card_ .content .imgBx {\n\tposition: relative;\n\twidth: 240px;\n\tjustify-content: center;\n\tjustify-items: center;\n\theight: 340px;\n\toverflow: hidden;\n\tborder-top-left-radius: 25px;\n\tborder-bottom-right-radius: 25px;\n\n}\n\n.container .card_ .content .imgBx img {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n}\n\n.container .card_ .content .contentBx h3 {\n\tcolor: #fff;\n\ttext-transform: uppercase;\n\tletter-spacing: 2px;\n\tfont-weight: 500;\n\tfont-size: 15px;\n\ttext-align: center;\n\tmargin: 20px 0 10px;\n\tline-height: 1.1em;\n}\n\n.container .card_ .content .contentBx h3 span {\n\tfont-size: 12px;\n\tfont-weight: 300;\n\ttext-transform: initial;\n}\n\n.container .card_ .sci {\n\tposition: absolute;\n\tbottom: 50px;\n\tdisplay: flex;\n}\n\n.container .card_ .sci li {\n\tlist-style: none;\n\tmargin: 0 10px;\n\ttransform: translateY(40px);\n\ttransition: 0.5s;\n\topacity: 0;\n}\n\n.container .card_:hover .sci li {\n\ttransform: translateY(0px);\n\topacity: 1;\n}\n\n.container .card_ .sci li a {\n\tcolor: #fff;\n\tfont-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
